import { gql } from "apollo-boost"

export const getRegionBudget = gql`
  query BudgetAvailability($where:DashboardProjectsWhere){
    BudgetAvailability(where: $where){
      region
      totalAmount
      count
    }
    ApprovedByRegion(where: $where) {
      region
      totalAmount
    }
  }
`